/** Scoutly staff platform roles (assignable when creating platform users). */
export const STAFF_PLATFORM_ROLE_OPTIONS = [
  { value: 'owner', label: 'Owner' },
  { value: 'platform_admin', label: 'Platform Admin' },
  { value: 'platform_support', label: 'Platform Support' },
] as const;

/** All platform role values including customer `none`. */
export const PLATFORM_ROLE_OPTIONS = [
  { value: 'none', label: 'None (customer account)' },
  ...STAFF_PLATFORM_ROLE_OPTIONS,
] as const;

export const PLATFORM_ROLE_VALUES = PLATFORM_ROLE_OPTIONS.map((option) => option.value);

/** @deprecated use PLATFORM_ROLE_VALUES */
export const MANAGEMENT_USER_ROLES = PLATFORM_ROLE_VALUES;

export type PlatformRole = (typeof PLATFORM_ROLE_VALUES)[number];

const PLATFORM_STAFF_ROLES = new Set([
  'owner',
  'platform_admin',
  'admin',
  'platform_support',
  'support',
  'platform_operator',
  'operator',
]);

export function isPlatformStaffRole(role: string): boolean {
  const normalized = role.trim().toLowerCase();
  if (normalized === 'none' || normalized === 'subscriber' || normalized === 'viewer') {
    return false;
  }
  return PLATFORM_STAFF_ROLES.has(normalized);
}

/** Staff with global source access — no per-user source assignment UI. */
export function roleHasImplicitSources(role: string): boolean {
  return isPlatformStaffRole(role);
}

export function isPlatformOwnerRole(role?: string | null): boolean {
  return normalizePlatformRole(role) === 'owner';
}

export function normalizePlatformRole(role?: string | null): string {
  const value = (role ?? 'none').trim().toLowerCase();
  if (value === 'admin') return 'platform_admin';
  if (value === 'support') return 'platform_support';
  if (value === 'operator' || value === 'platform_operator') return 'platform_support';
  if (value === 'subscriber' || value === 'viewer' || value === 'customer_admin') return 'none';
  return PLATFORM_ROLE_VALUES.includes(value as PlatformRole) ? value : 'none';
}
